import PropTypes from 'prop-types';
import get from 'lodash/get';
import { capitalize } from "lodash";

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';

// import LeadFilters from './LeadFilters';
import LeadsTable from './LeadsTable';
import LeadStatusTabs from './LeadStatusTabs';
import LoadingScreen from '../common/LoadingScreen';
import useIsMobile from '../../hooks/useIsMobile';

const TableView = props => {
  if (props.isLoading) return <LoadingScreen />;
  return (
    <Box>
      <LeadsTable
        {...props}
        rows={(props.rows || []).map(s => ({ data: s }))}
      />
    </Box>
  );
};

const ListLeadsScreen = props => {
  const { tab } = props;
  const tabName = tab !== 'all' ? capitalize(tab) : 'All Leads';
  // const { color, Icon } = getStatusOptions(tabName);
  const isMobile = useIsMobile();
  return (
    <Box className="list-session" marginTop='12px'>
      {/* <LeadFilters
        filters={props.filters}
        isPatient={props.isPatient}
        onFilterChange={props.onFilterChange}
      /> */}
      <Card className="list-session__card drop-shadow">
        <CardContent>
          <Box>
            <Box sx={{ display: {xs: 'none', md: 'block'}, marginLeft: '0.365rem'}}>
              <LeadStatusTabs {...props} />
            </Box>
          </Box>
          {Object.keys(props.rows).map(k =>
            tab === k
              ? <TableView
                isLoading={props.isLoading}
                title={`${k.toUpperCase()[0]}${k.slice(1)}`}
                category={k}
                rows={props?.rows?.[k] || []}
                pageSize={props.pageSize}
                pageIndex={get(props, `pageIndex[${k}]`) || 0}
                count={get(props, `counts[${k}]`)}
                onPageChange={props.onPageChange(k)}
                afterSave={get(props, `queries[${k}].refetch`) || null}
                isMobile={isMobile}
              />
              : null
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

ListLeadsScreen.propTypes = {
  filters: PropTypes.object,
  tab: PropTypes.string,
  counts: PropTypes.object,
};

export default ListLeadsScreen;
